import { Injectable } from '@angular/core';
import { AuthService } from '../../core/security/auth.service';
import * as _ from 'lodash';
import { ReportsV2Service as ReportsV2ApiService } from '../../api/services/reports-v-2.service';
import { ExportGroupsSummaryRequest } from '../../api/models/export-groups-summary-request';
import { NotificationService } from '../../notification/notification.service';
import { ExportGroupAgentsSummaryRequest } from '../../api/models/export-group-agents-summary-request';
import { ExportFieldModel } from '../../api/models/export-field-model';

@Injectable()
export class GroupsSummaryV2Service {
  public exportColumns: any[] = [
    { id: _.uniqueId('id_'), field: '_id', title: 'Account Number', width: 10 },
    { id: _.uniqueId('id_'), field: 'name', title: 'Name', width: 10 },
    { id: _.uniqueId('id_'), field: 'type', title: 'Type', width: 10 },
    { id: _.uniqueId('id_'), field: 'count', title: 'Total Calls', width: 10 },
    { id: _.uniqueId('id_'), field: 'answered', title: 'Answered', width: 10 },
    { id: _.uniqueId('id_'), field: 'missed', title: 'Abandoned', width: 10 },
    { id: _.uniqueId('id_'), field: 'durationIvrFormatted', title: 'Total Duration while IVR', width: 10 },
    { id: _.uniqueId('id_'), field: 'durationRingFormatted', title: 'Total Duration while Ring', width: 10 },
    { id: _.uniqueId('id_'), field: 'durationHoldFormatted', title: 'Total Duration while Hold', width: 10 },
    { id: _.uniqueId('id_'), field: 'durationTalkFormatted', title: 'Total Duration while Talk', width: 10 },
    { id: _.uniqueId('id_'), field: 'durationIdleFormatted', title: 'Total Duration while IDLE', width: 10 },
    { id: _.uniqueId('id_'), field: 'rwCount', title: 'Redirected while Waiting', width: 10 },
    { id: _.uniqueId('id_'), field: 'rrCount', title: 'Redirected while Ringing', width: 10 },
    { id: _.uniqueId('id_'), field: 'hwCount', title: 'Hung Up while Waiting', width: 10 },
    { id: _.uniqueId('id_'), field: 'hrCount', title: 'Hung Up while Ringing', width: 10 },
    { id: _.uniqueId('id_'), field: 'raCount', title: 'Redirected Anonymous Calls', width: 10 },
    { id: _.uniqueId('id_'), field: 'hbCount', title: 'Maximum Calls Reached', width: 10 },
    { id: _.uniqueId('id_'), field: 'userCount', title: 'Callers Redirected to Other Destinations', width: 10 },
    { id: _.uniqueId('id_'), field: 'soapCount', title: 'Redirected Due to Server Application', width: 10 },
  ];
  public exportAgentsColumns: any[] = [
    { id: _.uniqueId('id_'), field: 'extension', title: 'Account Number', width: 10 },
    { id: _.uniqueId('id_'), field: 'name', title: 'Name', width: 10 },
    { id: _.uniqueId('id_'), field: 'totalAnswered', title: 'Total Answered', width: 10 },
    { id: _.uniqueId('id_'), field: 'totalMissed', title: 'Calls Not Accepted', width: 10 },
    { id: _.uniqueId('id_'), field: 'totalLoggedInFormatted', title: 'Total Logged In', width: 10 },
    { id: _.uniqueId('id_'), field: 'totalDurationRingFormatted', title: 'Total Ring Time', width: 10 },
    { id: _.uniqueId('id_'), field: 'avgDurationRingFormatted', title: 'Average Ring Time', width: 10 },
    { id: _.uniqueId('id_'), field: 'totalDurationTalkFormatted', title: 'Total Talk Time', width: 10 },
    { id: _.uniqueId('id_'), field: 'avgDurationTalkFormatted', title: 'Average Talk Time', width: 10 },
  ];
  exportAgentsLoginLogoutColumns: ExportFieldModel[] = [
    {
      id: _.uniqueId('id_'),
      field: 'start',
      title: 'Date & Time',
      width: 20,
      style: { numFmt: 'DD/MM/YYYY hh:mm:ss AM/PM' },
    },
    //{ id: _.uniqueId('id_'), field: 'fromNumber', title: 'Agent', width: 10 },
    { id: _.uniqueId('id_'), field: 'fromFull', title: 'Agent', width: 20 },
    { id: _.uniqueId('id_'), field: 'callStatus', title: 'Action', width: 10 },
    //{ id: _.uniqueId('id_'), field: 'toNumber', title: 'Agent Group', width: 10 },
    { id: _.uniqueId('id_'), field: 'toFull', title: 'Agent Group', width: 20 },
  ];
  public aggregates: any[] = [
    { field: 'count', aggregate: 'sum' },
    { field: 'answered', aggregate: 'sum' },
    { field: 'missed', aggregate: 'sum' },
    { field: 'durationIvr', aggregate: 'sum' },
    { field: 'durationHold', aggregate: 'sum' },
    { field: 'durationIdle', aggregate: 'sum' },
    { field: 'durationRing', aggregate: 'sum' },
    { field: 'durationTalk', aggregate: 'sum' },
    { field: 'rwCount', aggregate: 'sum' },
    { field: 'rrCount', aggregate: 'sum' },
    { field: 'hwCount', aggregate: 'sum' },
    { field: 'hrCount', aggregate: 'sum' },
    { field: 'raCount', aggregate: 'sum' },
    { field: 'hbCount', aggregate: 'sum' },
    { field: 'userCount', aggregate: 'sum' },
  ];

  constructor(
    private authService: AuthService,
    private reportsApiService: ReportsV2ApiService,
    private notificationsService: NotificationService,
  ) {}

  public async exportLogs(state: ExportGroupsSummaryRequest): Promise<void> {
    console.log(state);

    await this.reportsApiService.groupsSummaryV2GetExport({ body: state }).toPromise();
    this.notificationsService.notifySuccess(
      'Export is in progress. You will get notification then download is finished.',
    );

    return;
  }

  public async exportAgentLogs(state: ExportGroupAgentsSummaryRequest): Promise<void> {
    console.log(state);

    await this.reportsApiService.groupsSummaryV2GetExportAgents({ body: state }).toPromise();
    this.notificationsService.notifySuccess(
      'Export is in progress. You will get notification then download is finished.',
    );

    return;
  }

  s2ab(s: string) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  }
}
